import React from "react";
import Title from "../Title/Title";
import "./BodyStyles.css";

function DashBody() {
	return (
		<>
			<div className='background'>
				<Title />
			</div>
		</>
	);
}

export default DashBody;
